import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
// import "devextreme/dist/css/dx.common.css";
import router from '../src/router/index'
import './assets/dx.material.material-orange-light-compact.css'

// import "@devexpress/analytics-core/dist/css/dx-analytics.common.css";
// import "@devexpress/analytics-core/dist/css/dx-analytics.light.css";
// import "@devexpress/analytics-core/dist/css/dx-querybuilder.css";
// import "devexpress-reporting/dist/css/dx-webdocumentviewer.css";
// import "devexpress-reporting/dist/css/dx-reportdesigner.css";


import config from 'devextreme/core/config'
import { locale } from 'devextreme/localization'
import {licenseKey} from "@/devextreme-license";

config({
    licenseKey
})

// Format RO (date dd.MM.yyyy, separatori numerici RO)
locale('ro')

loadFonts()

createApp(App)
  .use(router)
  .use(vuetify)
  .mount('#app')
